import Highcharts from "highcharts";
import annotations from "highcharts/modules/annotations";
import exporting from "highcharts/modules/exporting";
import nodata from "highcharts/modules/no-data-to-display.js";
import offline from "highcharts/modules/offline-exporting";
import sankey from "highcharts/modules/sankey";

// Single source of truth for Highcharts module registration. Import this once at
// the app entry (index.tsx) and in the test/storybook setup so every chart's
// modules are registered before any chart renders — instead of each chart
// component calling the module factory at top-level and relying on which
// component happens to import first (which breaks under code-splitting).
// Highcharts is a singleton, so registering here applies to every
// `import Highcharts from "highcharts"` caller. exporting must be registered
// before offline-exporting (offline-exporting depends on it).
nodata(Highcharts);
exporting(Highcharts);
offline(Highcharts);
sankey(Highcharts);
annotations(Highcharts);

export default Highcharts;
